import React, { useState, useCallback, useEffect, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import search from "../../../assets/Vehicles/search.png";
import close from "../../../assets/Vehicles/close_filter.png";
import fill_chevron_down from "../../../assets/Vehicles/fill_chevron_down.png";
import down from "../../../../src/assets/Vehicles/chevron_down.png";
import { useReactTable, getCoreRowModel, getSortedRowModel, getFilteredRowModel, flexRender } from "@tanstack/react-table";
import "../../Vehicles/Vehicle_list/List.css";
import { getRenewalReminderListApi } from "../renewal-api.js";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import lar from "../../../assets/svg/lar.svg";
import rar from "../../../assets/svg/rar.svg";
import DeleteModal from "../../common/delete-modal.js";
import { ViewUpcomingRenewal } from "./ViewUpcomingRenewal.jsx";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import DatePicker from "react-datepicker";
import { Calendar } from "lucide-react";

export const UpcomingReminder = () => {
  const columns = [
    {
      header: "Renewal ID",
      accessorKey: "renewal_id",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Renewal Name",
      accessorKey: "renewal_name",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "VIN",
      accessorKey: "vin",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "License No",
      accessorKey: "lic_no",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Vehicle Name",
      accessorKey: "vehicle_name",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Status",
      accessorKey: "status",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          <span>{info.getValue()}</span>
        </div>
      ),
    },
  ];

  const sortByList = [
    {
      value: "created asc",
      label: "Created (Oldest)",
    },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ];
  const [sortByValue, setSortByValue] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const [sortByField, setSortByField] = useState("created");
  const [sortByDir, setSortByDir] = useState("desc");

  const [globalFilter, setGlobalFilter] = useState("");
  const [selectedDate, setSelectedDate] = useState();

  const [renewalReminderList, setRenewalReminderList] = useState([]);
  const [listCount, setListCount] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    getRenewalReminderList();
  }, [itemsPerPage, itemOffset, globalFilter, sortByValue, selectedDate]);

  const getRenewalReminderList = async () => {
    try {
      const response = await getRenewalReminderListApi(`search=${globalFilter}&limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}&sort_field=${sortByField}&sort_dir=${sortByDir}&date=${selectedDate != null && selectedDate !== "" ? selectedDate.toLocaleDateString("en-CA") : ""}`);
      if (response.data.success === true) {
        setListCount(response.data.total_rec);
        setRenewalReminderList(response.data.reminders);
        setPageCount(response.data.total_pgs);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);

  const table = useReactTable({
    data: renewalReminderList ?? [],
    columns,
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });

  const [showRowOffcanvas, setShowRowOffcanvas] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const handleCloseRowOffcanvas = () => setShowRowOffcanvas(false);

  const handleRowClick = (rowData) => {
    setSelectedRowData(rowData);
    setShowRowOffcanvas(true);
  };

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const cancelDelete = () => {
    setDeleteId(null);
    setIsOpenDelete(false);
  };
  const onSuccessDelete = (response) => {
    setDeleteId(null);
    if (response.success === true) {
      setIsOpenDelete(false);
      getRenewalReminderList();
    }
  };
  const [hoveredRow, setHoveredRow] = useState(null);
  return (
    <>
      {isOpenDelete && <DeleteModal deleteUrl={`renewal/delete/${deleteId}`} onSuccess={onSuccessDelete} onCancel={cancelDelete} />}
      {showRowOffcanvas && <ViewUpcomingRenewal id={selectedRowData?.id} show={showRowOffcanvas} handleClose={handleCloseRowOffcanvas} />}
      <div className=" rounded-4" style={{ background: "#FFFFFF", margin: "16px" }}>
        <div className="d-flex p-3 flex-wrap align-items-center justify-content-between">
          <div className="d-flex flex-column">
            <p className="bg-transparent fw-bold dark-purple border-0 fs-24 assigned-dropdowns m-0">Upcoming Reminder</p>
            <p className="text-muted">{listCount} records</p>
          </div>
          <div className="d-flex flex-wrap gap-3">
            <div className="search-wrapper d-flex align-items-center gap-2 bg-white rounded-3 px-3 py-2">
              <img src={search} alt="search" />
              <input type="text" placeholder="Search" className="border-0 outline-0 rounded-3" value={globalFilter || ""} onChange={(e) => setGlobalFilter(e.target.value)} />
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="d-flex flex-wrap align-items-center justify-content-between p-3 gap-2">
          <div className="d-flex flex-wrap align-items-center gap-3">
            <p className="m-0 text-filter-grey fw-semibold">Filter :</p>
            <Dropdown data-tooltip-id="sort-tooltip" data-tooltip-content="Sort by">
              <Dropdown.Toggle id="dropdown-basic" className="bg-white text-purple search-border assigned-dropdown rounded-4 px-4 d-flex align-items-center gap-2">
                {sortByValue.label}
                <img src={fill_chevron_down} alt="chev down" />
                <img src={close} alt="x" />
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                {sortByList.map((item) => (
                  <Dropdown.Item
                    onClick={() => {
                      const arr = item.value.split(" ");
                      if (arr.length > 1) {
                        setSortByField(arr[0]);
                        setSortByDir(arr[1]);
                      }
                      setSortByValue(item);
                    }}
                  >
                    {item.label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
              <Tooltip id="sort-tooltip" place="top" />
            </Dropdown>
            <div className="w-15 w-md-25 w-lg-18 d-flex align-items-center bg-white text-purple search-border rounded-4" style={{ maxWidth: "180px" }} data-tooltip-id="date-tooltip" data-tooltip-content="Date">
              <DatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                dateFormat="dd-mm-yyyy"
                customInput={
                  <button style={{ color: "#8790A1" }} className="border-0 form-control vehicle-form-input bg-white rounded-4 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                    {selectedDate ? selectedDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd-mm-yyyy</span>}
                    <Calendar size={16} />
                  </button>
                }
              />
              <Tooltip id="date-tooltip" place="top" />
              {selectedDate != null && <img onClick={() => setSelectedDate(null)} src={close} alt="x" style={{ height: "30px" }} />}
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="p-3">
          <div className="table-wrapper overflow-x-auto">
            <table>
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th key={header.id} className="px-3 py-2" onClick={header.column.getToggleSortingHandler()}>
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {header.column.getIsSorted() === "asc" && " asc"}
                        {header.column.getIsSorted() === "desc" && " des"}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.map((row, index) => (
                  <tr
                    key={row.id}
                    style={{
                      position: "relative",
                      backgroundColor: hoveredRow === index ? "#F9F2FF" : "#ffffff",
                      cursor: "pointer",
                      transition: "border-color 0.3s",
                      borderLeft: hoveredRow === index ? "3px solid #471070" : "3px solid #E5E5E5",
                    }}
                    onMouseEnter={() => setHoveredRow(index)}
                    onMouseLeave={() => setHoveredRow(null)}
                    onClick={() => handleRowClick(row.original)}
                  >
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id} className="px-3 py-2">
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
            <Dropdown>
              <span className="pagination-color">Records per page: &nbsp;</span>
              <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0">
                <span className="bg-white no-of-rows rounded-3 px-2 py-2">
                  {itemsPerPage} <img src={down} alt="" />
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                {[10, 25, 50, 75, 100].map((size) => (
                  <Dropdown.Item
                    key={size}
                    onClick={() => {
                      setItemsPerPage(size);
                      setItemOffset(0);
                    }}
                    active={itemsPerPage === size}
                    className="text-center"
                  >
                    {size}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <div className="d-flex align-items-center gap-2">
              <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
